<template>
    <div class="login">
        <b-container class="login_box" id="box_adapter">
            <b-row v-if="!reg_form.consulente && !reg_form.installatore" style="height: 100%;">
                <b-col v-if="!registrazione" id="box_login" cols="12" lg="7">
                    <b-row>
                        <b-col>
                            <br>
                            <br>
                            <br>
                            <h1>Entra</h1>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" offset-md="1" md="9">
                            <br>
                            <br>
                            <br>
                            <b-input-group>
                                <b-input-group-prepend class="icon_form" is-text>
                                    <font-awesome-icon icon="user" />
                                </b-input-group-prepend>
                                <b-form-input class="input_form" v-model="email" size="lg" type="text" placeholder="Email"></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" offset-md="1" md="9">
                            <br>
                            <b-input-group>
                                <b-input-group-prepend class="icon_form" is-text>
                                    <font-awesome-icon icon="key" />
                                </b-input-group-prepend>
                                <b-form-input class="input_form" v-model="password" size="lg" type="password" placeholder="Password" v-on:keyup.enter="onSubmit()"></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <br>
                            <b-form-checkbox v-model="moreOnline">Resta online</b-form-checkbox>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <br>
                            <b-link style="border-bottom: 3px solid #eff5f3;">Password dimenticata?</b-link>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <br>
                            <b-button id="button_form" v-on:click="onSubmit()">ENTRA</b-button>
                            <br>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h5 style="margin: 0">Alcuni dei nostri partner:</h5>
                            <img style="margin: 15px" height="70" :src="require('@/assets/images/cardin_logo.jpg')" />
                            <img style="margin: 15px" height="70" :src="require('@/assets/images/csd.png')" />
                        </b-col>
                    </b-row>
                </b-col>
                <b-col id="box_laterale" cols="12" lg="5">
                    <b-row>
                        <b-col>
                            <h1 v-if="!registrazione">Registrati</h1>
                            <h1 v-if="registrazione">Entra</h1>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>        
                            <img width="300" height="140" :src="require('@/assets/images/marchio.png')" />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col offset="2" cols="8">
                            <br>
                            <h4 v-if="!registrazione">Vuoi accedere alla nostra piattaforma?</h4>
                            <h4 v-if="registrazione">Sei gia registrato sulla nostra piattaforma?</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <br>
                            <b-button id="button_form" v-if="!registrazione" v-on:click="apriRegistrazione()">REGISTRATI</b-button>
                            <b-button id="button_form" v-if="registrazione" v-on:click="chiudiRegistrazione()">ENTRA</b-button>
                            <br>
                            <br>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col v-if="registrazione" id="box_type_user" cols="12" lg="7">
                    <b-row>
                        <b-col>
                            <br>
                            <br>
                            <br>
                            <h1>Sei un:</h1>
                        </b-col>
                    </b-row>
                    <b-row style="padding-top: 10%;">
                        <b-col cols="12" lg="6">
                            <br>
                            <b-button class="button_type_user" v-on:click="registrazioneInstallatore()">
                                <b-row>
                                    <b-col>
                                        <font-awesome-icon class="icon_type_user" icon="user-cog" />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>Installatore</b-col>
                                </b-row>
                            </b-button>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <br>
                            <b-button class="button_type_user" v-on:click="registrazioneConsulente()">
                                <b-row>
                                    <b-col>
                                        <font-awesome-icon class="icon_type_user" icon="user-tie" />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>Consulente</b-col>
                                </b-row>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>

            
            <b-row v-if="reg_form.consulente && !fine" class="headerbox">
                <b-col>
                    <h5>Crea un Consulente</h5>
                </b-col>
            </b-row>
            <b-row v-if="reg_form.consulente && !fine">
                <b-col offset-lg="9">
                    <b-button class="button_close_registrazione" variant="danger" size="sm" v-on:click="indietroRegistrazione()"><font-awesome-icon icon="sign-out-alt" /> Esci</b-button>
                </b-col>
            </b-row>
            <form-wizard 
                title="" 
                subtitle=""
                nextButtonText="Avanti"
                backButtonText="Indietro"
                finishButtonText="Registrati"
                color="#493240"
                stepSize="xs"
                v-if="reg_form.consulente && !fine"
                >
                <tab-content title="Consulente" :before-change="consulenteStep1">
                    <b-row>
                        <b-col cols="12" md="6">
                            <b-form-input class="slide-up" id="denominazione" v-model="formData.consulente.denominazione" :state="state.denominazione" type="text" placeholder="Denominazione del consulente"/><label for="denominazione">* Denominazione</label>
                            <br>
                            <br>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-form-input class="slide-up" id="piva" v-model="formData.consulente.piva" :state="state.piva" type="text" placeholder="Partita IVA del consulente"/><label for="piva">* Partita IVA</label>
                            <br>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="6">
                            <b-form-input class="slide-up" id="cf" v-model="formData.consulente.cf" :state="state.cf" type="text" placeholder="Codice Fiscale del consulente"/><label for="cf">Codice Fiscale</label>
                            <br>
                            <br>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-form-input class="slide-up" id="email" v-model="formData.consulente.email" :state="state.email" type="text" placeholder="Email del consulente"/><label for="email">* Email</label>
                            <br>
                            <br>
                        </b-col>
                    </b-row>
                </tab-content>
                <tab-content title="Residenza" :before-change="consulenteStep2">
                    <b-row>
                        <b-col cols="12">
                            <b-form-input id="search_box" type="search" placeholder="Seleziona il tuo indirizzo" :state="state.search_address" autocomplete="off"></b-form-input>
                            <div id="ubicazione_map"></div>
                            <br>
                            <br>
                        </b-col>
                    </b-row>
                </tab-content>
                <tab-content title="Altre informazioni" :before-change="addConsulente">
                    <b-row>
                        <b-col cols="12" md="6">
                            <b-form-input class="slide-up" id="num_installatori" v-model="formData.consulente.num_installatori" :state="state.num_installatori" type="text" placeholder="Numero di installatori del consulente"/><label for="num_installatori">* Numero di Installatori</label>
                            <br>
                            <br>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-form-input class="slide-up" id="website" v-model="formData.consulente.website" :state="state.website" type="text" placeholder="Sito Web del consulente"/><label for="website">Sito Web</label>
                            <br>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="4">
                            <b-form-input class="slide-up" id="cellulare" v-model="formData.consulente.cellulare" :state="state.cellulare" type="text" placeholder="Cellulare del consulente"/><label for="cellulare">Cellulare</label>
                            <br>
                            <br>
                        </b-col>
                        <b-col cols="12" md="4">
                            <b-form-input class="slide-up" id="telefono" v-model="formData.consulente.telefono" :state="state.telefono" type="text" placeholder="Telefono del consulente"/><label for="telefono">Telefono</label>
                            <br>
                            <br>
                        </b-col>
                        <b-col cols="12" md="4">
                            <b-form-input class="slide-up" id="fax" v-model="formData.consulente.fax" :state="state.fax" type="text" placeholder="Fax del consulente"/><label for="fax">Fax</label>
                            <br>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-textarea class="slide-up" id="note" v-model="formData.consulente.note" :state="state.note" rows="3" max-rows="6" /><label for="note">Note</label>
                            <br>
                            <br>
                        </b-col>
                    </b-row>
                </tab-content>
            </form-wizard>

            <b-row v-if="reg_form.installatore && !fine" class="headerbox">
                <b-col>
                    <h5>Crea un Installatore</h5>
                </b-col>
            </b-row>
            <b-row v-if="reg_form.installatore && !fine">
                <b-col offset-lg="9">
                    <b-button class="button_close_registrazione" variant="danger" size="sm" v-on:click="indietroRegistrazione()"><font-awesome-icon icon="sign-out-alt" /> Esci</b-button>
                </b-col>
            </b-row>
            <form-wizard 
                title="" 
                subtitle=""
                nextButtonText="Avanti"
                backButtonText="Indietro"
                finishButtonText="Registrati"
                color="#493240"
                stepSize="xs"
                v-if="reg_form.installatore && !fine"
                class="wizard_box"
                >
                <tab-content title="Installatore" :before-change="installatoreStep1">
                    <b-row>
                        <b-col cols="12" md="6">
                            <b-form-input class="slide-up" id="denominazione" v-model="formData.installatore.denominazione" :state="state.denominazione" type="text" placeholder="Denominazione del consulente"/><label for="denominazione">* Denominazione</label>
                            <br>
                            <br>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-form-input class="slide-up" id="piva" v-model="formData.installatore.piva" :state="state.piva" type="text" placeholder="Partita IVA del consulente"/><label for="piva">* Partita IVA</label>
                            <br>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="6">
                            <b-form-input class="slide-up" id="cf" v-model="formData.installatore.cf" :state="state.cf" type="text" placeholder="Codice Fiscale del consulente"/><label for="cf">Codice Fiscale</label>
                            <br>
                            <br>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-form-input class="slide-up" id="email" v-model="formData.installatore.email" :state="state.email" type="text" placeholder="Email del consulente"/><label for="email">* Email</label>
                            <br>
                            <br>
                        </b-col>
                    </b-row>
                </tab-content>
                <tab-content title="Residenza" :before-change="installatoreStep2">
                    <b-row>
                        <b-col cols="12">
                            <b-form-input id="search_box" type="search" placeholder="Seleziona il tuo indirizzo" :state="state.search_address" autocomplete="off"></b-form-input>
                            <div id="ubicazione_map"></div>
                            <br>
                            <br>
                        </b-col>
                    </b-row>
                </tab-content>
                <tab-content title="Altre informazioni" :before-change="installatoreStep3">
                    <b-row>
                        <b-col cols="12" md="6">
                            <b-form-input class="slide-up" id="cod_attivazione" v-model="formData.installatore.cod_attivazione" :state="state.cod_attivazione" type="text" placeholder="Codice di attivazione dell'installatore"/><label for="cod_attivazione">Codice di Attivazione</label>
                            <br>
                            <br>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-form-input class="slide-up" id="website" v-model="formData.installatore.website" :state="state.website" type="text" placeholder="Sito Web del consulente"/><label for="website">Sito Web</label>
                            <br>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="4">
                            <b-form-input class="slide-up" id="cellulare" v-model="formData.installatore.cellulare" :state="state.cellulare" type="text" placeholder="Cellulare del consulente"/><label for="cellulare">Cellulare</label>
                            <br>
                            <br>
                        </b-col>
                        <b-col cols="12" md="4">
                            <b-form-input class="slide-up" id="telefono" v-model="formData.installatore.telefono" :state="state.telefono" type="text" placeholder="Telefono del consulente"/><label for="telefono">Telefono</label>
                            <br>
                            <br>
                        </b-col>
                        <b-col cols="12" md="4">
                            <b-form-input class="slide-up" id="fax" v-model="formData.installatore.fax" :state="state.fax" type="text" placeholder="Fax del consulente"/><label for="fax">Fax</label>
                            <br>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-textarea class="slide-up" id="note" v-model="formData.installatore.note" :state="state.note" rows="3" max-rows="6" /><label for="note">Note</label>
                            <br>
                            <br>
                        </b-col>
                    </b-row>
                </tab-content>
                
                <tab-content title="Logo" :before-change="installatoreStep4">
                    <b-row class="separatore_text">
                        <b-col>
                            <hr>
                        </b-col>
                        <b-col>
                            <h5>* LOGO</h5>
                        </b-col>
                        <b-col>
                            <hr>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <file-pond ref="logo" label-idle="* Trascina o seleziona il logo da caricare" allow-multiple="false" max-files="1"/>
                            <p style="color: grey">La dimensione massima del logo è di 25mb e i formati accettati sono: jpeg, png, bmp</p>
                        </b-col>
                    </b-row>
                </tab-content>
                <tab-content title="Documenti" :before-change="addInstallatore">
                    <b-row class="separatore_text">
                        <b-col>
                            <hr>
                        </b-col>
                        <b-col>
                            <h5>DURC</h5>
                        </b-col>
                        <b-col>
                            <hr>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8">
                            <file-pond ref="durc" label-idle="Trascina o seleziona il DURC da caricare" allow-multiple="false" max-files="1"/>
                        </b-col>
                        <b-col md="4" cols="12">
                            <VueCtkDateTimePicker v-model="formData.installatore.durc_scadenza" button-now-translation="Data attuale" format="DD-MM-YYYY" formatted="ll" :only-date="true" color="#493240">
                                <b-form-input v-model="formData.installatore.durc_scadenza" class="slide-up fix_datetime_picker" id="durc_scadenza" :state="state.durc_scadenza" type="text" placeholder="Data di scadenza del DURC"/><label for="durc_scadenza">Scadenza</label>
                            </VueCtkDateTimePicker>
                        </b-col>
                    </b-row>
                    <b-row class="separatore_text">
                        <b-col>
                            <hr>
                        </b-col>
                        <b-col>
                            <h5>VISURA CAMERALE</h5>
                        </b-col>
                        <b-col>
                            <hr>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8">
                            <file-pond ref="visura_camerale" label-idle="Trascina o seleziona la visura camerale da caricare" allow-multiple="false" max-files="1"/>
                        </b-col>
                        <b-col md="4" cols="12">
                            <VueCtkDateTimePicker v-model="formData.installatore.visura_camerale_scadenza" button-now-translation="Data attuale" format="DD-MM-YYYY" formatted="ll" :only-date="true" color="#493240">
                                <b-form-input v-model="formData.installatore.visura_camerale_scadenza" class="slide-up fix_datetime_picker" id="visura_camerale_scadenza" :state="state.visura_camerale_scadenza" type="text" placeholder="Data di scadenza della Visura Camerale"/><label for="visura_camerale_scadenza">Scadenza</label>
                            </VueCtkDateTimePicker>
                        </b-col>
                    </b-row>

                </tab-content>
            </form-wizard>

            <b-row v-if="fine" id="fine">
                <b-col>
                    <h2>Registrazione avvenuta con successo</h2>
                    <br>
                    <b-col offset-lg="1" lg="10"><h4>L’amministratore provvederà nel minor tempo possibile alla verifica dei suoi dati così da inviarle le credenziali di accesso alla piattaforma</h4></b-col>
                </b-col>
            </b-row>
        </b-container>

        <!--div id="ball1"></div-->
        <!--div id="ball2"></div-->
    </div>
</template>

<script>
import Vue from 'vue'
import { setTimeout } from 'timers'
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import { globalConf } from '../config.global'

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview)

var map
var markers

export default {
    components: {
        FilePond
    },
    data() {
        return {
            login: true,
            email: "",
            emailCode: "",
            password: "",
            moreOnline: false,
            code: false,
            registrazione: false,
            fine: false,
            reg_form: {
                installatore: false,
                consulente: false
            },
            formData: {
                installatore: {
                    denominazione: '',
                    piva: '',
                    cf: '',
                    email: '',
                    via: '',
                    civico: '',
                    nazione: '',
                    cap: '',
                    provincia: '',
                    comune: '',
                    cod_attivazione: '',
                    website: '',
                    cellulare: '',
                    telefono: '',
                    fax: '',
                    note: '',
                    durc_scadenza: '',
                    visura_camerale_scadenza: ''
                },
                consulente: {
                    denominazione: '',
                    piva: '',
                    cf: '',
                    email: '',
                    via: '',
                    civico: '',
                    nazione: '',
                    cap: '',
                    provincia: '',
                    comune: '',
                    num_installatori: '',
                    website: '',
                    cellulare: '',
                    telefono: '',
                    fax: '',
                    note: ''
                }
            },
            state: {
                denominazione: null,
                piva: null,
                cf: null,
                email: null,
                search_address: null,
                num_installatori: null,
                cod_attivazione: null,
                website: null,
                cellulare: null,
                telefono: null,
                fax: null,
                note: null,
                durc_scadenza: null,
                visura_camerale_scadenza: null
            }
        }
    },
    created: function(){
        Vue.loadScript("https://maps.googleapis.com/maps/api/js?key="+globalConf.gmaps+"&libraries=places")
        .catch((e) => {
            console.log("Errore durante il caricamento di Google Maps!\n"+e)
        })
    },
    methods: {
        onSubmit() {
            Vue.http.post('user/login', {email: this.email, password: this.password, moreOnline: this.moreOnline}, {credentials : true}).then(response => {
                if(response.body.success){
                    Vue.notify({
                        group: 'global',
                        title: 'Autenticazione eseguita',
                        text: 'Login eseguito con successo!',
                        type: 'success'
                    })
                    this.$router.push('/')
                }else{
                    if(response.body.licenza == false)
                        Vue.notify({
                            group: 'global',
                            title: 'Licenza non valida',
                            text: 'Il suo account non ha una licenza valida!',
                            type: 'error'
                        })
                    else
                        Vue.notify({
                            group: 'global',
                            title: 'Autenticazione non eseguita',
                            text: 'Assicurati di aver inserito tutti i dati correttamente!',
                            type: 'error'
                        })
                }
            }, response => {
                Vue.notify({
                    group: 'global',
                    title: 'Errore!',
                    text: 'Qualcosa è andato storto!',
                    type: 'error'
                })
            })
        },/*
        onSubmitCode() {
            Vue.http.post('user/sendcode', {email: this.emailCode}, {credentials : true}).then(response => {
                if(response.body.success){
                    Vue.notify({
                        group: 'global',
                        title: 'Successo',
                        text: 'Ti abbiamo inviato una mail con tutto il materiale utile al recupero della password!',
                        type: 'success'
                    })
                    this.code = true
                }else{
                    Vue.notify({
                        group: 'global',
                        title: 'Errore',
                        text: response.body.msg,
                        type: 'error'
                    })
                }
            }, response => {
                Vue.notify({
                    group: 'global',
                    title: 'Errore!',
                    text: 'Qualcosa è andato storto!',
                    type: 'error'
                })
            })
        },*/

        consulenteStep1(){
            for(var i=0; i<Object.keys(this.state).length; i++){
                this.state[Object.keys(this.state)[i]] = null
            }
            return Vue.http.post('registrazione/consulente/step1', {consulente: this.formData.consulente}, {credentials : true}).then(response => {
                if(response.body.success){
                    return true
                }else{
                    for(var i=0; i<response.body.inputError.length; i++){
                        this.state[response.body.inputError[i]] = false
                    }
                    
                    Vue.notify({
                        group: 'global',
                        title: 'Errore',
                        text: response.body.msg,
                        type: 'error'
                    })
                    return false
                }
            }, response => {
                Vue.notify({
                    group: 'global',
                    title: 'Errore',
                    text: "Errore durante la registrazione del consulente!",
                    type: 'error'
                })
                
                return false
            })
        },
        consulenteStep2(){
            for(var i=0; i<Object.keys(this.state).length; i++){
                this.state[Object.keys(this.state)[i]] = null
            }
            return Vue.http.post('registrazione/consulente/step2', {consulente: this.formData.consulente}, {credentials : true}).then(response => {
                if(response.body.success){
                    return true
                }else{
                    for(var i=0; i<response.body.inputError.length; i++){
                        this.state[response.body.inputError[i]] = false
                    }
                    
                    Vue.notify({
                        group: 'global',
                        title: 'Errore',
                        text: response.body.msg,
                        type: 'error'
                    })
                    return false
                }
            }, response => {
                Vue.notify({
                    group: 'global',
                    title: 'Errore',
                    text: "Errore durante la registrazione del consulente!",
                    type: 'error'
                })
                
                return false
            })
        },

        installatoreStep1(){
            for(var i=0; i<Object.keys(this.state).length; i++){
                this.state[Object.keys(this.state)[i]] = null
            }
            return Vue.http.post('registrazione/installatore/step1', {installatore: this.formData.installatore}, {credentials : true}).then(response => {
                if(response.body.success){
                    return true
                }else{
                    for(var i=0; i<response.body.inputError.length; i++){
                        this.state[response.body.inputError[i]] = false
                    }
                    
                    Vue.notify({
                        group: 'global',
                        title: 'Errore',
                        text: response.body.msg,
                        type: 'error'
                    })
                    return false
                }
            }, response => {
                Vue.notify({
                    group: 'global',
                    title: 'Errore',
                    text: "Errore durante la registrazione dell'installatore!",
                    type: 'error'
                })
                
                return false
            })
        },
        installatoreStep2(){
            for(var i=0; i<Object.keys(this.state).length; i++){
                this.state[Object.keys(this.state)[i]] = null
            }
            return Vue.http.post('registrazione/installatore/step2', {installatore: this.formData.installatore}, {credentials : true}).then(response => {
                if(response.body.success){
                    return true
                }else{
                    for(var i=0; i<response.body.inputError.length; i++){
                        this.state[response.body.inputError[i]] = false
                    }
                    
                    Vue.notify({
                        group: 'global',
                        title: 'Errore',
                        text: response.body.msg,
                        type: 'error'
                    })
                    return false
                }
            }, response => {
                Vue.notify({
                    group: 'global',
                    title: 'Errore',
                    text: "Errore durante la registrazione dell'installatore!",
                    type: 'error'
                })
                
                return false
            })
        },
        installatoreStep3(){
            for(var i=0; i<Object.keys(this.state).length; i++){
                this.state[Object.keys(this.state)[i]] = null
            }
            return Vue.http.post('registrazione/installatore/step3', {installatore: this.formData.installatore}, {credentials : true}).then(response => {
                if(response.body.success){
                    return true
                }else{
                    for(var i=0; i<response.body.inputError.length; i++){
                        this.state[response.body.inputError[i]] = false
                    }
                    
                    Vue.notify({
                        group: 'global',
                        title: 'Errore',
                        text: response.body.msg,
                        type: 'error'
                    })
                    return false
                }
            }, response => {
                Vue.notify({
                    group: 'global',
                    title: 'Errore',
                    text: "Errore durante la registrazione dell'installatore!",
                    type: 'error'
                })
                
                return false
            })
        },
        installatoreStep4(){
            /*if(this.$refs.logo.getFiles().length != 1){
                Vue.notify({
                    group: 'global',
                    title: 'Errore',
                    text: "Non è stato caricato nessun Logo!",
                    type: 'error'
                })
                return false
            }*/
            return true
        },

        loadMap(){
            map = new google.maps.Map(document.getElementById("ubicazione_map"), {
                center: {lat: 42.504154, lng: 12.646361},
                streetViewControl: false,
                zoom: 6
            })

            var input = document.getElementById('search_box')
            var searchBox = new google.maps.places.SearchBox(input)
            map.controls[google.maps.ControlPosition.TOP_LEFT].push(input)

            var localthis = this

            map.addListener('bounds_changed', function() {
                searchBox.setBounds(map.getBounds())
            })

            markers = []

            searchBox.addListener('places_changed', function() {
                var places = searchBox.getPlaces()

                localthis.setMap(places)
            })
        },
        setMap(places){
            this.state.search_address = null
            console.log(places)
            var check_msg = this.checkAddress(places)
            if(check_msg != ""){
                Vue.notify({
                    group: 'global',
                    title: 'Ubicazione errata!',
                    text: check_msg,
                    type: 'error'
                })
                this.state.search_address = false
                return
            }

            this.setByPlace(places)

            markers.forEach(function(marker) {
                marker.setMap(null)
            })
            markers = []

            var bounds = new google.maps.LatLngBounds()
            places.forEach(function(place) {
                if (!place.geometry) {
                    console.log("Returned place contains no geometry")
                    return
                }
                var icon = {
                    url: place.icon,
                    size: new google.maps.Size(71, 71),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(17, 34),
                    scaledSize: new google.maps.Size(25, 25)
                }

                markers.push(new google.maps.Marker({
                    map: map,
                    icon: icon,
                    title: place.name,
                    position: place.geometry.location
                }))

                if (place.geometry.viewport) {
                    bounds.union(place.geometry.viewport)
                } else {
                    bounds.extend(place.geometry.location)
                }
            })
            map.fitBounds(bounds)
        },
        checkAddress(places){
            if(this.reg_form.consulente){
                this.formData.consulente.via = ''
                this.formData.consulente.civico = ''
                this.formData.consulente.nazione = ''
                this.formData.consulente.cap = ''
                this.formData.consulente.provincia = ''
                this.formData.consulente.comune = ''
            }else if(this.reg_form.installatore){
                this.formData.installatore.via = ''
                this.formData.installatore.civico = ''
                this.formData.installatore.nazione = ''
                this.formData.installatore.cap = ''
                this.formData.installatore.provincia = ''
                this.formData.installatore.comune = ''
            }

            if(places.length == 0 || places.length > 1){
                return "Assicurati di aver selezionato correttamente la tua ubicazione e di aver selezionato un punto bel preciso!"
            }

            var luogo = places[0].formatted_address

            document.getElementById('search_box').value = luogo
            
            var campi = luogo.split(",")

            if(campi.length != 4){
                return "L'indirizzo inserito non è completo di tutte le informazioni necessarie!"
            }

            if(campi[1].trim().split(" ").length != 1){
                return "Assicurati di aver selezionato correttamente la tua ubicazione e di aver selezionato un punto bel preciso!"
            }

            if(!(campi[3].trim() == "Italia" || campi[3].trim() == "Italy")){
                return "Attualmente sono supportati solo indirizzi italiani! Per qualsiasi dubbio contattare l'assistenza."
            }

            var sub_campi = campi[2].trim().split(" ")

            if(sub_campi.length < 3)
                return "L'indirizzo inserito non è valido!"

            if(isNaN(Number.parseInt(sub_campi[0].trim())))
                return "L'indirizzo inserito non contiene un CAP valido! Riprovare."

            if(sub_campi[sub_campi.length - 1].trim().length != 2)
                return "La provincia inserita non è valida!"

            return ""
        },
        setByPlace(places){
            var luogo = places[0].formatted_address
            console.log(luogo)

            document.getElementById('search_box').value = luogo

            var campi = luogo.split(",")

            var sub_campi = campi[2].split(" ")

            if(this.reg_form.consulente){
                this.formData.consulente.via = campi[0]
                this.formData.consulente.civico = campi[1]
                this.formData.consulente.nazione = campi[3] //TODO: se cerco indirizzo fuori italia ho problemi nella formattazione dell'indirizzo
                this.formData.consulente.cap = sub_campi[1]
                this.formData.consulente.provincia = sub_campi[sub_campi.length - 1]
                this.formData.consulente.comune = sub_campi.slice(2, sub_campi.length - 1).join(" ")
            }else if(this.reg_form.installatore){
                this.formData.installatore.via = campi[0]
                this.formData.installatore.civico = campi[1]
                this.formData.installatore.nazione = campi[3] //TODO: se cerco indirizzo fuori italia ho problemi nella formattazione dell'indirizzo
                this.formData.installatore.cap = sub_campi[1]
                this.formData.installatore.provincia = sub_campi[sub_campi.length - 1]
                this.formData.installatore.comune = sub_campi.slice(2, sub_campi.length - 1).join(" ")
                
            }
        },

        apriRegistrazione(){
            this.registrazione = true
        },
        chiudiRegistrazione(){
            this.registrazione = false
        },
        registrazioneInstallatore(){
            this.reg_form.installatore = true
            setTimeout(this.loadMap, 500)
        },
        registrazioneConsulente(){
            this.reg_form.consulente = true
            setTimeout(this.loadMap, 500)
        },

        addInstallatore(){
            var form = new FormData()
            form.append("body", JSON.stringify({installatore: this.formData.installatore}))
            
            if(this.$refs.logo.getFiles().length == 1)
                form.append('logo', this.$refs.logo.getFiles()[0].file, this.$refs.logo.getFiles()[0].file.name)
            /*else
                return Vue.notify({
                    group: 'global',
                    title: 'Errore',
                    text: "Non è stato caricato nessun Logo!",
                    type: 'error'
                })*/

            if(this.$refs.durc.getFiles().length == 1)
                form.append('durc', this.$refs.durc.getFiles()[0].file, this.$refs.durc.getFiles()[0].file.name)

            if(this.$refs.visura_camerale.getFiles().length == 1)
                form.append('visura_camerale', this.$refs.visura_camerale.getFiles()[0].file, this.$refs.visura_camerale.getFiles()[0].file.name)
            
            return Vue.http.post('registrazione/installatore', form, {credentials : true}).then(response => {
                if(response.body.success){
                    this.fine = true

                    setTimeout(() => {
                        location.reload()
                    }, 10000)
                    return true
                }else{
                    for(var i=0; i<Object.keys(this.state).length; i++){
                        this.state[Object.keys(this.state)[i]] = null
                    }

                    for(var i=0; i<response.body.inputError.length; i++){
                        this.state[response.body.inputError[i]] = false
                    }
                    
                    Vue.notify({
                        group: 'global',
                        title: 'Errore',
                        text: response.body.msg,
                        type: 'error'
                    })
                    return false
                }
            }, response => {
                Vue.notify({
                    group: 'global',
                    title: 'Errore',
                    text: "Errore durante la registrazione dell'installatore!",
                    type: 'error'
                })
                
                return false
            })
        },
        addConsulente(){
            return Vue.http.post('registrazione/consulente', {consulente: this.formData.consulente}, {credentials : true}).then(response => {
                if(response.body.success){
                    this.fine = true

                    setTimeout(() => {
                        location.reload()
                    }, 10000)
                    return true
                }else{
                    for(var i=0; i<Object.keys(this.state).length; i++){
                        this.state[Object.keys(this.state)[i]] = null
                    }

                    for(var i=0; i<response.body.inputError.length; i++){
                        this.state[response.body.inputError[i]] = false
                    }
                    
                    Vue.notify({
                        group: 'global',
                        title: 'Errore',
                        text: response.body.msg,
                        type: 'error'
                    })
                    return false
                }
            }, response => {
                Vue.notify({
                    group: 'global',
                    title: 'Errore',
                    text: "Errore durante la registrazione del consulente!",
                    type: 'error'
                })
                
                return false
            })
        },
        indietroRegistrazione(){
            this.reg_form.installatore = false
            this.reg_form.consulente = false
        }
    }
}
</script>

<style scoped>
.login{
    position: relative;
    overflow: hidden;
    padding-top: 10vh;
    padding-bottom: 20px;
    background: #f0f4f3;
    height: 100vh;
}

.login_box{
    position: relative;
    height: 80vh;
    max-height: 900px;
    background: white;
    border-radius: 15px;
    overflow: hidden;

    -webkit-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
    -moz-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
    box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
    z-index: 1;
}

#box_login{
    color: #493240;
    text-align: center;
}

#box_laterale{
    background: #493240;
    color: white;
    text-align: center;
    padding: 0;
    padding-top: 20%;
}

#box_type_user{
    color: #493240;
    text-align: center;
    margin-bottom: 20px;
}

.input_form{
    background-color: #f4f6f8 !important;
    border: 0 !important;
    height: 60px !important;
    border-top-left-radius: 0.3rem !important;
    border-bottom-left-radius: 0.3rem !important;
}

.icon_form div{
    background-color: transparent !important;
    border: 0;
}

#button_form{
    background-color: #493240;
    font-size: 25px;
    padding: 15px 100px;
    border-radius: 30px;
    border-color: white;
}

.button_close_registrazione{
    margin-top: 15px;
}

.button_type_user{
    background-color: white;
    color: #493240;
    width: 100%;
    font-size: 20px;
    text-align: center;
    padding: 35px;
    border-radius: 20px;
    border-color: #493240;
}

.button_type_user:hover{
    background-color: #493240;
    color: white;
}

.icon_type_user{
    font-size: 100px;
    margin-bottom: 20px;
}

#fine{
    color: #493240;
    text-align: center;
    padding-top: 10%;
}

#search_box{
  width: 60%;
  margin-top: 10px;
  margin-left: 20px;
}

#ubicazione_map{
  width: 100%;
  height: 400px;
  border-radius: 4px;

  -webkit-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
  -moz-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
  box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
}

#logo_box{
    position: relative;
    width: 80%;
    height: 200px;
    z-index: 1;
    margin-left: 10%;
    margin-right: 10%;
}

#logo_box > div > div > img{
    border-radius: 2px;
    margin-top: 10px;
    margin-left: 10px;

    -webkit-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
    -moz-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
    box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
}

#ball1{
    position: fixed;
    top: 65vh;
    left: -100px;
    width: 500px;
    height: 500px;
    background: #493240;
    z-index: 0;
    border-radius: 500px;
}

#ball2{
    position: fixed;
    top: -100px;
    right: -100px;
    width: 500px;
    height: 500px;
    background: #493240;
    z-index: 0;
    border-radius: 500px;
}

@media only screen and (max-width: 991px) {
    .login_box{
        height: auto !important;
        max-height: none !important;
    }

    .login{
        overflow-y: auto;
    }

    #search_box{
        width: calc(60% - 60px);
    }
}

@media only screen and (max-width: 768px) {
    #search_box{
        margin-top: 60px;
        margin-left: 0;
    }
}

@media only screen and (max-width: 576px) {
    .login{
        padding: 0;
    }

    .login_box{
        border-radius: 0;
        height: 100vh;
        min-height: 100vh;
        overflow-y: auto;
        overflow-x: hidden;
    }
}

@media only screen and (max-height: 850px) and (min-width: 992px) {  
  #box_adapter{
    height: auto !important;
    max-height: none !important;
  }

  .login{
    overflow-y: auto;
  }
}

#denominazione{
  text-indent: 150px;
}

#piva{
  text-indent: 120px;
}

#cf{
  text-indent: 135px;
}

#email{
  text-indent: 85px;
}

#num_installatori{
  text-indent: 200px;
}

#cod_attivazione{
  text-indent: 180px;
}

#website{
  text-indent: 95px;
}

#cellulare{
  text-indent: 95px;
}

#telefono{
  text-indent: 95px;
}

#fax{
  text-indent: 60px;
}

#note{
  text-indent: 70px;
  line-height: 1.8;
}

#durc_scadenza{
  text-indent: 100px;
}

#visura_camerale_scadenza{
  text-indent: 100px;
}
</style>
